import { render, staticRenderFns } from "./CustomUserLayout.vue?vue&type=template&id=38fdaa26&scoped=true"
import script from "./CustomUserLayout.vue?vue&type=script&lang=js"
export * from "./CustomUserLayout.vue?vue&type=script&lang=js"
import style0 from "./CustomUserLayout.vue?vue&type=style&index=0&id=38fdaa26&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fdaa26",
  null
  
)

export default component.exports